import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Assignments from 'components/Assignments';
import Spinner from 'components/Spinner';
import StopsDetails from 'components/StopsDetails';
import SideBar from 'components/SideBar';
import JourneyInfoSide from 'components/JourneyInfoSide';
import PodStatus from 'components/PodStatus';
import Documentation from 'components/Documentation';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'hooks/useAuth/useAuth';
import { getJobDetailUrl, fetcher } from 'utils/network/http';
import { useParams, useLocation } from 'react-router-dom';
import useSWR from 'swr';
import Price from 'components/Price';

const JobDetail = ({ className }) => {
  const { t } = useTranslation('Jobs');
  const { profile } = useAuth();
  const { id } = useParams();
  const [journey, setJourney] = useState(null);
  const { data: journeyData, error, mutate: refetchJourney } = useSWR(
    profile ? getJobDetailUrl(id) : null,
    fetcher,
    {
      refreshInterval: 60000,
    }
  );
  let location = useLocation();

  useEffect(() => {
    setJourney(journeyData ? journeyData.data : null);
  }, [journeyData]);

  const renderJob = useCallback(() => {
    if (error) {
      return (
        <div className="job-detail__error" data-testid="error">
          <span>{t('errorDetailJob')}</span>
        </div>
      );
    }

    if (!journey) {
      return (
        <div className="job-detail__loading" data-testid="loading">
          <Spinner />
        </div>
      );
    }

    if (journey)
      return (
        <>
          <SideBar
            backLabel={t('back')}
            redirectRoute={location?.state?.backRoute}
          >
            <JourneyInfoSide journey={journey} />
            <Assignments
              driverId={journey.driver_id}
              vehiclesIds={journey.vehicles_id}
              driverConfirmed={journey.driver_confirmed}
              showAtSide
              withoutTag
            />
            <PodStatus
              journeyId={journey.id}
              stops={journey.stops}
              full_status={journey.full_status}
              refetchData={refetchJourney}
              journeyStatus={journey.status}
            />
            <Documentation
              journeyId={journey.id}
              journeyStatus={journey.status}
            />
            <div className="job-detail__side-block">
              <Price
                price={journey.net_full_cost}
                currency={journey.currency}
                showForSide
                showPrice={parseFloat(journey.net_full_cost) > 0.0}
                vat={journey.gross_full_cost}
              />
            </div>
          </SideBar>
          <div className="job-detail__body" data-testid="job-detail__journey">
            <StopsDetails
              expanded
              withStatus
              journey={journey}
              refetchData={refetchJourney}
            />
          </div>
        </>
      );
  }, [journey, error, t, refetchJourney, location]);
  return (
    <div className={className} data-testid="job-detail">
      <div className="job-detail">{renderJob()}</div>
    </div>
  );
};
JobDetail.propTypes = {
  className: PropTypes.string,
};
export default JobDetail;
